import { supabase } from '../../lib/supabase';
import { TestSublease } from '../../types/test-sublease';

/**
 * Fetch sublease data from Supabase for the test page
 * This is a dedicated service for the test page, separate from any existing services
 */
export async function fetchTestSubleases(): Promise<{ data: TestSublease[] | null; error: Error | null }> {
  try {
    // Using a simpler approach with a foreign table join
    const { data, error } = await supabase
      .from('subleases')
      .select(`
        lease_id,
        lease_holder,
        lease_start,
        lease_end,
        lease_method,
        lease_type,
        lease_furth_term,
        lease_rent_freq,
        lease_dealing,
        lease_deal_doc,
        leaseholders:lease_holder(holder_name)
      `)
      .order('lease_id', { ascending: true });

    if (error) {
      console.error('Error fetching test subleases:', error);
      return { data: null, error: error as Error };
    }

    // Transform the data to flatten the nested leaseholders object
    const transformedData = data?.map(item => {
      // Extract the holder_name from the nested leaseholders object
      const leaseholderData = item.leaseholders as unknown as { holder_name: string } | null;
      
      return {
        lease_id: item.lease_id,
        lease_holder: item.lease_holder,
        holder_name: leaseholderData?.holder_name || 'N/A',
        lease_start: item.lease_start,
        lease_end: item.lease_end,
        lease_method: item.lease_method,
        lease_type: item.lease_type,
        lease_furth_term: item.lease_furth_term,
        lease_rent_freq: item.lease_rent_freq,
        lease_dealing: item.lease_dealing,
        lease_deal_doc: item.lease_deal_doc
      };
    }) as TestSublease[] | null;

    return { data: transformedData, error: null };
  } catch (error) {
    console.error('Unexpected error fetching test subleases:', error);
    return { data: null, error: error as Error };
  }
}
